// import { Component } from '@angular/core';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';


@Component({
  selector: 'app-repledger',
  templateUrl: './repledger.component.html',
  styleUrls: ['./repledger.component.scss']
})
export class RepledgerComponent {

  currentDate: Date;

  start_date = '';
  end_date = '';
  rep_name = '';
  departmentTypes: string[] = [];
  getalldata: any[];
  getalldata1: any;
  getallentries: any[];
  combinedData: any;
  groupedData: any[] = [];
  crData: any[] = [];
  drData: any[] = [];
  pairedData: any[] = [];

  constructor(private dialogRef: MatDialogRef<RepledgerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    // private cdr: ChangeDetectorRef,private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.currentDate = new Date();
    this.start_date = this.data['startDate'];
    this.end_date = this.data['endDate'];
    this.rep_name = this.data['repname'];
    this.departmentTypes = this.data['departmentTypes'];

    this.service.getrepledgerinfo(this.start_date, this.end_date, this.rep_name, this.departmentTypes).subscribe((data1) => {
      this.combinedData = data1;

      this.service.getrepledgerinfo1(this.start_date, this.end_date, this.rep_name, this.departmentTypes).subscribe((data2) => {
        this.combinedData = this.combinedData.concat(data2);
        this.groupCombinedData(); // Group data after loading
      });
    });
  }

  // groupCombinedData() {
  //   const voucherMap = new Map<string, any>();

  //   for (const item of this.combinedData) {
  //     const key = item.voucher_no + '_' + item.voucher_type;

  //     // Split department_type and voucher_amt into arrays
  //     const departments = item.department_type.split(',').map((d: string) => d.trim());
  //     const amounts = item.voucher_amt.split(',').map((a: string) => a.trim());

  //     // Combine departments and amounts into an array of objects
  //     const voucherDetails = departments.map((dept: string, index: number) => ({
  //       department_type: dept,
  //       voucher_amt: amounts[index] || ''
  //     }));

  //     if (!voucherMap.has(key)) {
  //       voucherMap.set(key, {
  //         voucher_no: item.voucher_no,
  //         voucher_date: item.voucher_date,
  //         rep_name: item.rep_name,
  //         voucher_type: item.voucher_type,
  //         voucherDetails: voucherDetails
  //       });
  //     } else {
  //       const existing = voucherMap.get(key);
  //       existing.voucherDetails = existing.voucherDetails.concat(voucherDetails);
  //     }
  //   }
  //   debugger
  //   this.groupedData = Array.from(voucherMap.values());
  // }

  // groupCombinedData() {
  //   const voucherMap = new Map<string, any>();

  //   for (const item of this.combinedData) {
  //     const key = item.voucher_no + '_' + item.voucher_type;

  //     const departments = item.department_type.split(',').map((d: string) => d.trim());
  //     const amounts = item.voucher_amt.split(',').map((a: string) => a.trim());

  //     const voucherDetails = departments.map((dept: string, index: number) => ({
  //       department_type: dept,
  //       voucher_amt: amounts[index] || ''
  //     }));

  //     if (!voucherMap.has(key)) {
  //       voucherMap.set(key, {
  //         voucher_no: item.voucher_no,
  //         voucher_date: item.voucher_date,
  //         rep_name: item.rep_name,
  //         voucher_type: item.voucher_type,
  //         voucherDetails: voucherDetails
  //       });
  //     } else {
  //       const existing = voucherMap.get(key);
  //       existing.voucherDetails = existing.voucherDetails.concat(voucherDetails);
  //     }
  //   }

  //   const groupedArray = Array.from(voucherMap.values());

  //   // Separate CR and DR data
  //   this.crData = groupedArray.filter(item => item.voucher_type === 'CR');
  //   this.drData = groupedArray.filter(item => item.voucher_type === 'DB');

  //   // Pair CR and DR entries row by row
  //   const maxLength = Math.max(this.crData.length, this.drData.length);
  //   this.pairedData = [];

  //   for (let i = 0; i < maxLength; i++) {
  //     this.pairedData.push({
  //       cr: this.crData[i] || null,
  //       dr: this.drData[i] || null
  //     });
  //   }
  // }

  groupCombinedData() {
    const voucherMap = new Map<string, any[]>();

    // Step 1: Group all voucherDetails by voucher_no
    for (const item of this.combinedData) {
      const key = item.voucher_no;
      const departments = item.department_type.split(',').map((d: string) => d.trim());
      const amounts = item.voucher_amt.split(',').map((a: string) => a.trim());

      const voucherDetails = departments.map((dept: string, index: number) => ({
        department_type: dept,
        voucher_amt: amounts[index] || ''
      }));

      const entry = {
        voucher_no: item.voucher_no,
        voucher_date: item.voucher_date,
        rep_name: item.rep_name,
        voucher_type: item.voucher_type,
        voucherDetails: voucherDetails
      };

      if (!voucherMap.has(key)) {
        voucherMap.set(key, []);
      }
      voucherMap.get(key)!.push(entry);
    }

    // Step 2: Build paired data from voucherMap
    const pairedMap = new Map<string, any>();
    voucherMap.forEach((entries, voucher_no) => {
      const crEntry = entries.find(e => e.voucher_type === 'CR') || null;
      const drEntry = entries.find(e => e.voucher_type === 'DB') || null;

      const date = crEntry?.voucher_date || drEntry?.voucher_date || null;

      pairedMap.set(voucher_no, {
        voucher_no,
        voucher_date: date,
        cr: crEntry,
        dr: drEntry
      });
    });

    // Step 3: Convert to array and sort by date
    const pairedArray = Array.from(pairedMap.values());
    pairedArray.sort((a, b) => new Date(a.voucher_date).getTime() - new Date(b.voucher_date).getTime());

    this.pairedData = pairedArray;
  }

}